<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div
      style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;"
    >小乐手表</div>
    <div style="padding: 20px;">
      <div>
        <el-row>
          <div style="float:right">
             <el-input
              placeholder="请输入老人姓名"
              v-model="name"
              clearable
              style="margin:0 5px;width:200px"
            ></el-input>
            <el-input
              placeholder="请输入Imei号" 
              v-model="imei"
              clearable
              style="margin:0 5px;width:200px"
            ></el-input>
            <el-input
              placeholder="请输入手机号"
              v-model="phone"
              clearable
              style="margin:0 5px;width:200px"
            ></el-input>
            <el-select v-model="governmentCode"  placeholder="请选择运营商" style="margin:0 10px">
              <el-option
                  v-for="item in governmentList"
                  :key="item.governmentCode"
                  :label="item.name"
                  :value="item.governmentCode">
              </el-option>
            </el-select>
            <el-button
              style="margin-left:10px;float:right"
              type="primary"
              icon="el-icon-search"
              @click="getList(true)"
            >搜索</el-button>
          </div>
        </el-row>

        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>
          <el-table v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
            <el-table-column prop="elderlyName" label="用户姓名"></el-table-column>

            <el-table-column prop="phone" label="手机号"></el-table-column>

            <el-table-column prop="imei" label="Imei号"></el-table-column>

            <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter"></el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="RemoveBinding(scope.row)">解绑</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div
              style="float: left;padding: 5px;"
            >共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      phone: "",
      imei: "",
      name:'',
      plateform:'shop',
      governmentList:[],
      governmentCode:''
    };
  },
  components: {},
  created() {
    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      console.log(val);
      this.th = val;
    },
  },
  methods: {
    init(){
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Government/GetNormalGovernment",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.governmentList = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceTogWatch/PageByPlateform",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          phone: this.phone,
          imei: this.imei,
          pageSize: this.pageSize,
          name:this.name,
          plateform:this.plateform,
          governmentCode:this.governmentCode
        },
      })
        .then((response) => {
          _this.tableLoading=false
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          _this.tableLoading=false
          console.log(error);
        });
    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
            this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceTogWatch/RemoveBinding",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userCode: row.userCode,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.$message({
              message: "解绑成功",
              type: "success",
            });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>

<style scoped>
</style>
